module.exports = __webpack_public_path__ + "static/Grafika7@2x-c71558540afe871bbc5a7d4f1567943f.png";